import { isArray, isEmpty } from '@dimjs/lang';
import { CheckListValue } from './context';

export const getValueList = (value: CheckListValue, multiple?: boolean) => {
  if (value !== undefined && !isEmpty(value)) {
    const valueList = isArray(value) ? value : [value];
    return multiple ? valueList : valueList.splice(0, 1);
  }
  return null;
};
